import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchPersonRelations = withSuspense(lazy(() => import('./c2p-relation-search')));
export default SearchPersonRelations;
